import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { batchListPath } from "@saleor/reports/batch/urls";
import React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles(
  () => ({
    btnContainer: {
      alignItems: "center",
      color: "#247CFF",
      cursor: "pointer",
      display: "inline-flex",
      textDecoration: "none"
    },
    label: {
      cursor: "pointer",
      marginLeft: "10px"
    }
  }),
  {
    name: "BackButton"
  }
);

function BackButton(props) {
  const classes = useStyles(props);

  return (
    <Link className={classes.btnContainer} to={batchListPath}>
      <ArrowBackIcon />
      <label className={classes.label}>Back to Active Batches</label>
    </Link>
  );
}

export default BackButton;
